import { ToggleGroup, ToggleGroupItem } from 'components/ToggleGroup';
import { Flex } from 'components/layout';
import { cn } from 'utils/shadcn';

import { QuoteMode } from './types';

interface QuoteModeToggleProps {
  quoteMode: QuoteMode;
  setQuoteMode: (quoteMode: QuoteMode) => void;
}

export function QuoteModeToggle({
  quoteMode,
  setQuoteMode,
}: QuoteModeToggleProps) {
  return (
    <Flex justify='between' gap='sm' align='center' className='mb-4'>
      <ToggleGroup
        type='single'
        value={quoteMode}
        onValueChange={(value: QuoteMode) => setQuoteMode(value)}
        className='relative bg-neutral-100 border border-neutral-300 rounded-md p-1 grid w-full grid-cols-2 gap-0 m-0'
      >
        {/* Sliding background */}
        <div
          className={cn(
            'absolute top-1 bottom-1 w-[calc(50%-4px)] rounded-md bg-brand-main transition-all duration-200 ease-in-out',
            {
              'left-1': quoteMode === QuoteMode.TL,
              'left-[calc(50%+1px)]': quoteMode === QuoteMode.LTL,
            }
          )}
        />

        <ToggleGroupItem
          value={QuoteMode.TL}
          aria-label='TL'
          className='relative z-10 flex-1 bg-transparent border-0 shadow-none data-[state=on]:text-white data-[state=off]:text-neutral-600'
        >
          TL
        </ToggleGroupItem>
        <ToggleGroupItem
          value={QuoteMode.LTL}
          aria-label='LTL'
          className='relative z-10 flex-1 bg-transparent border-0 shadow-none data-[state=on]:text-white data-[state=off]:text-neutral-600'
        >
          LTL
        </ToggleGroupItem>
      </ToggleGroup>
    </Flex>
  );
}
